/**
 * Returns a copy of an object with its properties in a stable order
 * @param {Record<string, any>} object
 * @returns {Record<string, any>}
 */

function normalize(object, seen = new Set()) {
    if (!(typeof object === "object") || !object) return object
    if (seen.has(object)) return null
    seen.add(object)
    if (Array.isArray(object)) {
        const output = []
        for (let i = 0, l = object.length; i < l; i++) {
            output.push(normalize(object[i], seen))
        }
        return output
    }
    return Object.fromEntries(
        Object.entries(object)
            .sortBy("0")
            .map(([key, value]) => [key, normalize(value, seen)])
    )
}

/**
 * Stringifies an object with its properties in a stable order
 * @param {Record<string, any>} object
 * @param replacer
 * @returns {string}
 */
function normalizedStringify(object, replacer) {
    return JSON.stringify(normalize(object), replacer)
}

function onlyStandardProperties(item, omit = () => false, invalidChars = ["$", "_"]) {
    return normalizedStringify(item, (k, v) => (omit(k) || invalidChars.some((c) => k.startsWith(c)) ? undefined : v))
}

function isSame(a, b, { omit, invalidChars = ["$", "_"] } = {}) {
    a = onlyStandardProperties(a, omit, invalidChars) ?? "{}"
    b = onlyStandardProperties(b, omit, invalidChars) ?? "{}"
    return a === b
}

export { normalize }
export { normalizedStringify }
export { onlyStandardProperties as stringifyOnlyStandardProperties }
export { isSame }
